"use client";
import {
  createDisclosureStore
} from "./IHNLLH3I.js";

// src/dialog/dialog-store.ts
function createDialogStore(props = {}) {
  return createDisclosureStore(props);
}

export {
  createDialogStore
};
